const en = {
    messages: {
        pricing: 'Pricing',
        blog: 'Blog',
        blogdescription: 'The latest about RPA CLOUD',
        profile: 'Profile',
        signout: 'Sign out',
        signin: 'Sign in',
        tryforfree: 'Try for free',
        privacypolicy: 'Privacy policy',
        contact: 'Contact',
        opensettings: 'Open settings',
        signintoocto: 'Sign in to {name}',
        welcomeback: 'Welcome back!',
        pleasesignin: 'Please sign in.',
        email: 'Email',
        password: 'Password',
        forgotyourpassword: 'Forgot your password?',
        forgotyourpassworddescription: 'Enter the email address you usually sign in with. If the account exists, we\'ll email you a reset link that you can use to reset your password.',
        emailaddress: 'Email address',
        sendpasswordreset: 'Send password reset',
        sendpasswordresetmsg: 'We have sent an email to {email}, with a link to reset your password. The link will be valid for 10 minutes.',
        resetyourpassword: 'Reset your password',
        resetyourpassworddescription: 'Enter the new your password.',
        resetpassword: 'Reset password',
        newpassword: 'New password',
        confirmpassword: 'Confirm password',
        firstname: 'First name',
        lastname: 'Last name',
        agreetryforfree: 'Agree, Try for free',
        free: 'Free',
        standard: 'Standard',
        premium: 'Premium',
        enterprise: 'Enterprise',
        cooperation: 'Cooperation',
        agreeconfirm: 'By clicking below, you agree with the terms of ',
        tel: 'Tel',
        useastrongpassword: 'Use a strong password',
        whichplanwouldyouliketouse: 'Which package would you like to use?',
        weak: 'Weak',
        okay: 'Okay',
        good: 'Good',
        strong: 'Strong',
        stronger: 'Stronger',
        tooshort: 'Too short',
        talktous: 'Talk to us',
        talktousdescription: 'Fill in the form below and we\'ll get back to you promptly.',
        talktousdescription2: 'Prefer to get in touch directly?',
        orphone: 'or phone',
        whatcanwehelpwith: 'What can we help with?',
        send: 'Send',
        phonenumber: 'Phone number',
        rpacloudslogan: 'RPA CLOUD - Your ideal assistant provider',
        rpaclouddescription: 'RPA CLOUD is a user-friendly, cloud-based software robot that helps users automate their repetitive tasks at an affordable price. It works 24/7, and you don’t need to be a developer to use it.',
        contactsales: 'Contact sales',
        feature: 'Feature',
        featuredescription: 'Let\'s experience the unique features that RPA CLOUD brings to you.',
        bynow: 'Buy Now',
        months: 'month',
        standardprice: '$15',
        standarddescription: [
            '1 account included',
            '5 robots included',
            '5 tasks schedule included',
            '1 GB of storage',
            'Email support',
        ],
        premiumprice: '$30',
        premiumdescription: [
            '1 account included',
            '10 robots included',
            '10 tasks schedule included',
            '10 connections included',
            '2 GB of storage',
            'Priority email support',
        ],
        enterpriseprice: '$50',
        enterprisedescription: [
            '5 accounts included',
            '30 robots included',
            '30 tasks schedule included',
            '30 connections included',
            '10 GB of storage',
            'Phone & email support',
        ],
        cooperationprice: '',
        cooperationdescription: [
            'Unlimited accounts included',
            'Unlimited robots included',
            'Unlimited tasks schedule included',
            'Unlimited connections included',
            'Private storage',
            'Private server',
            'Priority support',
        ],
        tryforstandard: 'Try for Standard',
        tryforstandarddescription: 'You just selected the Standard package',
        agreetryforstandard: 'Agree, Try for Standard',
        tryforpremium: 'Try for Premium',
        tryforpremiumdescription: 'You just selected the Premium package which costs',
        agreetryforpremium: 'Agree, Try for Premium',
        tryforenterprise: 'Try for Enterprise',
        tryforenterprisedescription: 'You just selected the Enterprise package which costs',
        agreetryforenterprise: 'Agree, Try for Enterprise',
        searchblog: 'Search Blog',
        pricingdescription: 'Our package includes Standard, Premium, Enterprise, and Cooperation. Choose the package that suits your needs.',
        close: 'Close',
        almostdone: 'Almost done!',
        pleaseverifyyouremailaddress: 'Please verify your email address.',
        wehavesentanemailto: 'We\'ve sent an email to:',
        pleasecheckittoverifyyouremail: 'Please check it to verify your email.',
        needhelp: 'Need help?',
        contactusat: 'contact us at',
        resendverificationemail: 'Resend verification email',
        msg_resendverificationemailalert: 'We have sent an email to {email}. You\'ll need to follow the link in the email to verify your email. This link is valid for 1 hour.',
        pleaseenteravalidemailaddress: 'Please enter a valid email address.',
        pleaseenteravalidfirstname: 'First name can only contain letters, spaces, \'-\', \'.\', or an apostrophe.',
        pleaseenteravalidlastname: 'Last name can only contain letters, spaces, \'-\', \'.\', or an apostrophe.',
        pleaseenteravalidpassword: 'The password must be at least 8 charaters, and at least 1 uppercase, and 1 number.',
        pleaseenteravalidcompanyname: 'Please enter the valid company name.',
        pleaseenteravalidtelnumber: 'Please enter valid tel number.',
        msg_error: 'A system error has occurred.',
        msg_invalidinformation: 'Invalid email or password. Please try again or contact us.',
        msg_emailisalreadyexists: 'The email you provided is already in use. Please sign in to your RPA CLOUD account.',
        msg_invalidverifyemailtoken: 'Unfortunately this verification link has expired. Please sign in to your RPA CLOUD and click the "Resend verification email" button to generate a new link.',
        dashboard: 'Dashboard',
        dashboarddescription: 'Hi, Welcome to RPA CLOUD.',
        cancel: 'Cancel',
        ok: 'OK',
        signoutconfirm: 'Are you sure sign out of your RPA CLOUD account?',
        msg_resetpasswordsuccess: 'Reset password success.',
        msg_invalidemail: 'No user with this email address exists.',
        passwordisnotmatch: 'New password and confirm password do not match.',
        msg_thenewpasswordisthesameasthelastpassword: 'The new password is the same as the last password.',
        changelanguage: 'Change language',
        pleaseenteravalidphonenumber: 'Please enter a valid phone number.',
        pleasefilloutthisfield: 'Please fill out this field.',
        msg_thanksforcontactingus: 'Thanks for contacting us. We\'ll get back to you as soon as we can.',
        registernow: 'Don\'t have an account? Register now',
        documentation: 'Documentation',
        user: 'User',
        workspace: 'Robot',
        connection: 'Connection',
        storage: 'Storage',
        storages: 'Storage',
        userprofile: 'User Profile',
        userinfor: 'User Infor',
        edityouraccountinformation: 'Edit your account information:',
        save: 'Save',
        changeyourpassword: 'Change your password',
        currentpassword: 'Current password',
        dashboarddescription_2: 'By allowing the robots to remember the task, routine work can be executed automatically and repeatedly.',
        dashboarddescription_3: 'Easy RPA even for beginners.',
        dashboarddescription_4: 'You can visually capture the operations performed by the user on the screen and request commands from the robot. Since it is possible to easily carry out the work that humans have repeated one by one, the work burden can be reduced.',
        upgrade: 'Upgrade',
        currentplan: 'Current package',
        schedule: 'Schedule',
        tasksdonetoday: 'Tasks done today',
        name: 'Name',
        timezone: 'Timezone',
        description: 'Description',
        result: 'Result',
        triggers: 'Triggers',
        role: 'Role',
        package: 'Package',
        verified: 'Verified',
        yes: 'Yes',
        no: 'No',
        success: 'Success',
        error: 'Error',
        administrator: 'Administrator',
        expiration: 'Expiration',
        action: 'Action',
        upload: 'Upload',
        active: 'Active',
        inactive: 'Inactive',
        status: 'Status',
        providerid: 'Provider ID',
        size: 'Size',
        robotunit: 'robot(s)',
        connectunit: 'connect(s)',
        gbunit: 'GB',
        taskunit: 'task(s)',
        delete: 'Delete',
        deleted: 'Deleted',
        thekeynameisalreadyinuse: 'The key name is already in use.  Please provide a unique key name.',
        createddt: 'Created Date',
        kind: 'Kind',
        addnew: 'Add new',
        search: 'Search',
        download: 'Download',
        id: 'ID',
        details: 'Details',
        startdatetime: 'Start Date and Time',
        enddatetime: 'End Date and Time',
        histories: 'Histories',
        gmail: 'Google mail',
        clicktocopy: 'Click to copy',
        duplicate: 'Duplicate',
        build: 'Build',
        run: 'Run',
        back: 'Back',
        options: 'Options',
        thisfieldisrequired: 'This field is required.',
        url: 'Url',
        selector: 'Selector',
        text: 'Text',
        browser: 'Browser',
        outputkey: 'Output key',
        condition: 'Condition',
        undo: 'Undo',
        redo: 'Redo',
        specifycalculation: 'Specify calculation',
        openbrowser: 'Open Browser',
        click: 'Click',
        if: 'If',
        endif: 'End If',
        comment: 'Comment',
        miscellaneous: 'Miscellaneous',
        control: 'Control',
        update: 'Update',
        rowsperpage: 'Rows per page',
        msg_youraccounthasbeenupdated: 'Your account has been updated.',
        msg_fileextensionsarenotallowed: 'File extensions are not allowed.',
        msg_pleaseuploadthefile: 'Please upload the file.',
        msg_fileistoobig: 'File is too big (max 10MB).',
        msg_youravatarhasbeenupdated: 'Your avatar has been updated.',
        msg_currentpasswordisinvalid: 'Current password is invalid.',
        msg_newpasswordandconfirmpassworddoesnotmatch: 'New password and confirm password does not match.',
        msg_changepasswordsuccess: 'Change password successfully.',
        addnewuser: 'Add new user',
        edituser: 'Update user',
        language: 'Language',
        english: 'English',
        vietnamese: 'Tiếng Việt',
        japanese: '日本語',
        languageofverifyemail: 'Language of verify email',
        msg_addnewusersuccess: 'Add new user successful.',
        msg_editusersuccess: 'Update user successful.',
        msg_inactiveuserwassuccess: 'Inactive user(s) was successful.',
        msg_activeuserwassuccess: 'Active user(s) was successful.',
        msg_deleteuserwassuccess: 'Delete user(s) was successful.',
        confirmactionuser: 'Do you want to {action} the selected user?',
        uploadfile: 'Upload File',
        filepath: 'File path',
        projects: 'Projects',
        projectname: 'Project name',
        members: 'Members',
        robots: 'Robots',
        createddate: 'Created date',
        createduser: 'Created user',
        projectnameexample: 'Demo project',
        descriptionexample: 'This is a demo project',
        deleteprojectconfirm: 'Are you sure delete "{projectName}"?',
        deleteprojectsubtitle: 'Please type [delete] to confirm.',
        msg_addnewprojectsuccess: 'Add new project successful.',
        msg_editprojectsuccess: 'Update project was successful.',
        msg_deleteprojectwassuccess: 'Delete project was successful.',
        msg_deleteprojecterror: 'You can not delete the project because it\'s contain other robots.',
        updaterobot: 'Update robot',
        addnewrobot: 'Add new robot',
        robotname: 'Robot name',
        icon: 'Icon',
        backgroundcolor: 'Background color',
        color: 'Color',
        sendinganemailwhenanerroroccurs: 'Sending an email when an error occurs',
        msg_addnewscriptsuccess: 'Add new robot was successful.',
        msg_editscriptsuccess: 'Update robot was successful.',
        msg_deletescriptwassuccess: 'Delete robot was successful.',
        deletescriptconfirm: 'Are you sure delete "{scriptName}"?',
        duplicaterobot: 'Duplicate robot',
        msg_duplicatescriptsuccess: 'Duplicate robot successful.',
        msg_savescriptwassuccess: 'Save script successful.',
        gmailconnectiondescription: 'View or send emails.',
        googlespreadsheetsconnectiondescription: 'Read or write a sheet.',
        googledriveconnectiondescription: 'See, edit, create, and delete all files.',
        googlecalendarconnectiondescription: 'Get or set calendar events.',
        awss3connectiondescription: 'Download or upload files to S3.',
        filemakerconnectiondescription: 'Read or write a record and execute script.',
        googledocsconnectiondescription: 'Read or write all documents.',
        ftpconnectiondescription: 'Download or upload files to FTP.',
        bucketname: 'Bucket Name',
        accesskeyid: 'Access Key ID',
        secretaccesskey: 'Secret Access Key',
        host: 'Host',
        version: 'Version',
        username: 'User Name',
        database: 'Database',
        msg_updateconnectionsuccess: 'Update connection success',
        msg_createconnectionsuccess: 'Create connection success',
        msg_cannotupdateconnection: 'Can not update connection',
        msg_cannotcreateconnection: 'Can not create connection',
        connectionlist: 'Connection List',
        msg_pleaseenterthedataintherequiredfield: 'Please enter the data in the required field',
        deleteconnectionconfirm: 'Are you sure delete "{name}"?',
        msg_deleteconnectionwassuccess: 'Delete connection was successful.',
        copiedtoclipboard: 'Copied to clipboard',
        copypath: 'Copy path',
        path: 'Path',
        totalsize: 'Total size',
        msg_deletestoragesuccess: 'Delete file/directory was successful.',
        deletedirectoryconfirm: 'Are you sure delete selected file/directory?',
        addnewsubdirectory: 'Add new sub directory',
        uploadfilestodirectory: 'Upload files to directory',
        directory: 'Directory',
        directories: 'Directories',
        actions: 'Actions',
        type: 'Type',
        directoryname: 'Directory name',
        msg_directoryalreadyexists: 'The directory already exists.',
        msg_addnewsubdirectorysuccess: 'Add new sub directory was successful.',
        uploadfilestodirectoryconfirm: 'Do you want to upload files to "{name}" directory?',
        msg_uploadfilessuccess: 'Upload files to directory was successful.',
        editdirectoryname: 'Edit directory name',
        msg_updatedirectorysuccess: 'Update directory was successful.',
        disabled: 'Disabled',
        ready: 'Ready',
        disable: 'Disable',
        enable: 'Enable',
        running: 'Running',
        selectrobot: 'Select robot',
        edittrigger: 'Edit trigger',
        confirmschedule: 'Confirm schedule',
        next: 'Next',
        msg_addnewschedulesuccess: 'Add new schedule was successful.',
        msg_updateschedulesuccess: 'Update schedule was successful.',
        msg_deleteschedulewassuccess: 'Delete schedule was successful.',
        confirmactionschedule: 'Do you want to {action} the selected schedule?',
        msg_enableschedulrwassuccess: 'Enable schedule(s) was successful.',
        msg_disableschedulrwassuccess: 'Disable schedule(s) was successful.',
        msg_expireduser: 'The account has been expired.',
        expirationnotice: 'You have {numberOfValidDays} day(s) left to use RPA CLOUD.',
        expirationnotice_2: 'To avoid any disruption, please contact the admin.',
        runscriptconfirm: 'Would you like to run "{scriptName}"?',
        selectyourprojectname: 'Select your project name',
        enteryourrobotname: 'Enter your robot name',
        screenshot: 'Screenshot',
        basicauthusername: 'Username (Basic Auth)',
        basicauthpassword: 'Password (Basic Auth)',
        clearvalue: 'Clear value',
        keyboards: 'Keyboards',
        downloadfile: 'Download File',
        stop: 'Stop',
        steps: 'Steps',
        step: 'Step',
        acceptdialog: 'Accept dialog',
        paste: 'Paste',
        copy: 'Copy',
        msg_missingifstep: 'Missing "If" step',
        msg_missingendifstep: 'Missing "End If" step',
        msg_missingendloopstep: 'Missing "End Loop" step',
        msg_missingloopstep: 'Missing "Loop" step',
        msg_missingendforeachstep: 'Missing "End For-each" step',
        msg_missingforeachstep: 'Missing "For-each" step',
        msg_invalidscriptstep: 'Invalid script step',
        concatenate: 'Concatenate',
        parentheses: 'Parentheses',
        equalto: 'Equal To',
        notequalto: 'Not Equal To',
        greaterthan: 'Greater Than',
        lessthan: 'Less Than',
        greaterthanorequalto: 'Greater Than Or Equal To',
        lessthanorequalto: 'Less Than Or Equal To',
        carriagereturn: 'Carriage Return',
        plus: 'Plus',
        minus: 'Minus',
        multiply: 'Multiply',
        divide: 'Divide',
        and: 'And',
        or: 'Or',
        not: 'Not',
        get: 'Get',
        msg_thespecifiedfieldcannotbefound: 'Cannot be found: {caculation}',
        msg_missing: 'Missing {name}',
        textismustbeinbetweendoublequotation: 'Text is must be in between double quotation (ex: "abc")',
        ignoreerror: 'Ignore error',
        actionsfordownload: 'Actions for download',
        selectoption: 'Select Option',
        coordinatex: 'Coordinate X',
        coordinatey: 'Coordinate Y',
        windowsize: 'Window size',
        format: 'Format',
        scale: 'Scale',
        pageranges: 'Page ranges',
        timeout: 'Timeout (millisecond)',
        findelementby: 'Find element by',
        attribute: 'Attribute',
        tab: 'Tab',
        waitfornavigation: 'Wait for navigation',
        fullpage: 'Full page',
        targetselector: 'Target selector',
        destinationselector: 'Destination selector',
        kill: 'Kill',
        msg_killschedulewassuccess: 'Kill schedule(s) was successful.',
        createddatetime: 'Created datetime',
        view: 'View',
        executor: 'Executor',
        msg_pleaseupgradeyourplantocreateanewrobot: 'Please upgrade your package to create a new robot.',
        msg_pleaseupgradeyourplantocreateanewconnection: 'Please upgrade your package to create a new connection.',
        msg_pleaseupgradeyourplantouploadfile: 'Your storage is full. Please remove unnecessary files/folders from your storage or upgrade your current package.',
        msg_pleaseupgradeyourplantocreateanewschedule: 'Please upgrade your package to create a new schedule.',
        termsofuse: 'Terms of use',
        date: 'Date',
        number: 'Number',
        logical: 'Logical',
        value: 'Value',
        gettingstarted: 'Getting started',
        usage: 'Usage',
        connections: 'Connections',
        iwouldliketoupgradepackage: 'I would like to upgrade package for RPA CLOUD.',
        message: 'Message',
        pleaseenteravalidphonemessage: 'Please enter a valid phone message.',
        msg_toomanyrequestsfromthisip: 'Too many requests from this IP, please try again after an hour.',
        benefitsofusingrpacloud: 'Benefits of using RPA CLOUD',
        benefitsofusingrpaclouddescription: 'RPA CLOUD automates repetitive tasks, saving time and money while ensuring accurate execution.',
        savetime: 'Save time',
        costefficiency: 'Cost efficiency',
        accuratetask: 'Accurate task',
        howtouserpacloud: 'How to use RPA CLOUD?',
        howtouserpaclouddescription: 'You only need to have an internet-connected PC to enjoy its simplicity.',
        createyourrobot: 'Create your robot',
        createyourrobotdescription: 'Imagine it as a digital assistant that can observe and replicate your actions on a computer. You simply guide the robot through each step, just as you would when performing the task yourself.',
        testtherobot: 'Test the Robot',
        testtherobotdescription: 'By utilizing the "Run" function,  you can ensure that the robot has been programmed correctly and will execute the desired actions in a smooth and efficient manner. ',
        settheschedule: 'Set the schedule',
        setthescheduledescription: 'Specify the time frame in which you would like the robot to perform designated tasks on your behalf, you can simply sit back, relax, and let the robot do the work for you.',
        uniquefeature: 'Explore unique features of RPA CLOUD',
        uniquefeaturedescription: 'RPA CLOUD offers a diverse range of functions that can be performed across multiple platforms including Google Chrome, Excel, Gmail, Google Spreadsheet, Google Drive, Google Calendar, Google Docs, AWS S3, and FileMaker. ',
        code: 'Code',
        incrediblyeasytogetgoing: 'Incredibly easy to get going',
        times: 'Times',
        iterable: 'Iterable',
        scheduled: 'Scheduled',
        msg_cannotdeletescriptbecause: 'You can not delete the robot because it\'s has been scheduled.',
        freeupto30daysnocreditcardrequired: 'Free up to 30 days. No credit card required.',
        filename: 'File name',
        fullpath: 'Full path',
        encoding: 'Encoding',
        array: 'Array',
        object: 'Object',
        arraydata: 'Array data',
        arrayindex: 'Index of array',
        objectdata: 'Object data',
        objectkey: 'Key of object',
        createarray: 'Create Array',
        element: 'Element',
        deleteelement: 'Delete element',
        addnewelement: 'Add new element',
        key: 'Key',
        deleteobject: 'Delete object',
        addnewobject: 'Add new object',
        createobject: 'Create Object',
        splitwith: 'Split with',
        find: 'Find',
        replacewith: 'Replace with',
        regexp: 'Regexp',
        sheetname: 'Sheet name',
        newsheetname: 'New sheet name',
        worksheet: 'Worksheet',
        celllabel: 'Cell label',
        range: 'Range',
        headers: 'Headers',
        contents: 'Contents',
        json: 'JSON',
        excel: 'Excel',
        drive: 'Google Drive',
        calendar: 'Google Calendar',
        installation: 'Installation',
        usageperiod: 'Usage period',
        copylink: 'Copy link',
        chromeextension: 'Chrome extension',
        setvariable: 'Set variable',
        runjavascript: 'Run javascript',
        subtitle__gettingstarted_installation: ' In order to automate website operations using RPA CLOUD s web browser functionality, you will need to install a Chrome extension called "RPA CLOUD" for copying CSS selectors.CSS selectors are like name tags for people attending a party.Just like a name tag identifies a specific person in a room full of people, CSS selectors identify specific elements on a website.',
        getcssselector: 'Get CSS Selector',
        subtitle__gettingstarted_usage: 'Learn the fundamentals of using RPA CLOUD.',
        actiontask: 'Action tasks',
        makeyourfirstrobot: 'Create your first robot',
        runyourrobot: 'Run your robot',
        schedulerobotrun: 'Schedule robot run',
        msg_companyName_invalid: 'Company name is invalid.',
        msg_telNumber_invalid: 'Tel number is invalid.',
        msg_firstName_invalid: 'First name is invalid.',
        msg_lastName_invalid: 'Last name is invalid.',
        msg_password_invalid: 'Password is invalid.',
        msg_plan_invalid: 'Pakage is invalid.',
        msg_locale_invalid: 'Locale is invalid.',
        msg_paymentfailed: 'Payment failed. Please try again.',
        msg_paymentsuccess: 'Payment success.',
        chromiumtitle: 'Working with the Chrome browser',
        chromiumdescription: 'Most of what you can do manually in the browser can be done here such as create screenshots and PDFs of pages,automatically submit forms, test UI, enter data by keyboard, download files, upload files, etc.',
        exceltitle: 'Working with Excel',
        exceldescription: 'Things like reading/adding/deleting/editing data in Excel can all be done here. You can also read/write CSV files, convert Excel to CSV and more.',
        gmailtitle: 'Working with Gmail',
        gmaildescription: 'This feature allows you to send emails from your Gmail account through the Gmail API. In addition, you can search for messages in your mailbox, get content, download attachments, and more.',
        googlespreadsheettitle: 'Working with Google Spreadsheet',
        googlespreadsheetdescription: 'This feature allows you to read/add/delete/edit data in a worksheet using the Google Spreadsheet API. Also you can add new, copy, download sheet files etc.',
        googledrivetitle: 'Working with Google Drive',
        googledrivedescription: 'This feature allows you to manage files in Drive including uploading and downloading through the Google Drive API.',
        googlecalendartitle: 'Working with Google Calendar',
        googlecalendardescription: 'This feature allows you to manage your calendars and events through the Google Calendar API.',
        googledocstitle: 'Working with Google Docs',
        googledocsdescription: 'This feature allows you to read/write all documents through the Google Calendar API.',
        awss3title: 'Working with AWS S3',
        awss3description: 'By linking to AWS S3, you can load files and save them to an S3 bucket. S3 bucket operation permission is an IAM permission specified in the AWS console.',
        filemakertitle: 'Working with FileMaker',
        filemakerdescription: 'Based on the API that FileMaker provides, you can read/add/delete/edit records in FileMaker, also you can execute the script in FileMaker etc.',
        texttitle: 'Working with Text files',
        textdescription: 'Convert .txt/PDF files to text.Also you can split/replace/search/uppercase/lowercase etc.',
        docs: 'Google Docs',
        filemaker: 'FileMaker',
        awss3: 'AWS S3',
        clientid: 'client ID',
        to: 'To',
        subject: 'Subject',
        body: 'Body',
        attachments: 'Attachments',
        from: 'From',
        cc: 'CC',
        bcc: 'BCC',
        query: 'Query',
        limit: 'Limit',
        markasread: 'Mark as read',
        gmailmessages: 'Gmail messages',
        calendarid: 'Calendar ID',
        summary: 'Summary',
        descriptions: 'Descriptions',
        eventid: 'Event ID',
        attendees: 'Attendees',
        fileid: 'File ID',
        spreadsheetid: 'Spreadsheet ID',
        title: 'Title',
        spreadsheet: 'Google Spreadsheet',
        spreadsheetdestination: 'Spreadsheet (destination)',
        sheetnamedestination: 'Sheet name (destination)',
        extension: 'Extension',
        method: 'Method',
        params: 'Params',
        httpheaders: 'Headers',
        layout: 'Layout',
        parameters: 'Parameters',
        fielddata: 'Field data',
        recordid: 'Record ID',
        scriptname: 'Script name',
        containerfieldname: 'Container fieldname',
        globalfields: 'Global fields',
        webservice: 'Web Service',
        msg_cannotrunschedulerightnow: 'Schedule is running, can\'t run schedule right now.',
        msg_scheduleisdisabled: 'Schedule is disabled.',
        msg_schedulehasrunsuccessfully: 'Schedule has run successfully.',
        createyouritemandstartexperimentingnow: 'Create your {item} and start experimenting now.',
        script: 'Script',
        passwords: 'Password',
        documentid: 'Document ID',
        document: 'Document',
        index: 'Index',
        function: 'Function',
        functions: 'Functions',
        subtitle__actiontask_miscellaneous: 'Some basic actions to start using RPA CLOUD.',
        parameters__title: 'Parameter (* is a required parameter)',
        parameters__name: 'Name',
        parameters__type: 'Type',
        parameters__description: 'Description',
        parameters__default: 'Default',
        returndatatype__title: 'Return data type',
        example__title: 'Example',
        datatype__text: 'Text',
        datatype__number: 'Number',
        datatype__array: 'Array (JSON)',
        datatype__object: 'Object (JSON)',
        datatype__boolean: 'Boolean',
        datatype__any: 'Any',
        dependingonstoredvalue: '(depending on stored value)',
        subtitle__actiontask_browser: 'List of browser actions. Browser actions correspond to activities like starting the browser and clicking inside the browser. Set CSS selectors for manipulating elements in the browser etc.',
        supplement__title: 'Supplement',
        textonly: 'Text only',
        typetext: 'Type Text',
        typepassword: 'Type Password',
        keyboardpress: 'Keyboard Press',
        gettext: 'Get Text',
        clickpoint: 'Click Point',
        takescreenshot: 'Take Screenshot',
        pagepdf: 'Page PDF',
        hover: 'Hover',
        scrapepage: 'Scrape Page',
        findelement: 'Find Element',
        geturl: 'Get URL',
        getattribute: 'Get Attribute',
        waitforselector: 'Wait For Selector',
        draganddrop: 'Drag And Drop',
        injectjavascript: 'Inject JavaScript',
        gotourl: 'Go To Url',
        goback: 'Go Back',
        switchtab: 'Switch Tab',
        showtabs: 'Show Tabs',
        closebrowser: 'Close Browser',
        subtitle__actiontask_storages: 'List of actions for manipulating files or folders in the storage.',
        listfiles: 'List Files',
        renamefile: 'Rename File',
        movefiles: 'Move Files',
        deletefiles: 'Delete Files',
        copyfiles: 'Copy Files',
        compressfiles: 'Compress Files',
        decompressfiles: 'Decompress Files',
        subtitle__actiontask_json: 'List of actions that handle data like arrays and objects.',
        getelementfromarray: 'Get Element From Array',
        getvaluefromobject: 'Get Value From Object',
        subtitle__actiontask_text: 'List of actions that manipulate strings.',
        createtext: 'Create Text',
        splittext: 'Split Text',
        replacetext: 'Replace Text',
        matchtext: 'Match Text',
        readtext: 'Read Text',
        convertpdftotext: 'Convert PDF To Text',
        convertexceltocsv: 'Convert Excel To CSV',
        subtitle__actiontask_excel: 'List of actions to operate Excel files.',
        createnewfile: 'Create New File',
        getsheetnames: 'Get Sheet Names',
        changesheetname: 'Change Sheet Name',
        selectsheet: 'Select Sheet',
        readcell: 'Read Cell',
        writecell: 'Write Cell',
        readrange: 'Read Range',
        writerange: 'Write Range',
        deleterange: 'Delete Range',
        appendvaluetotextfile: 'Append Value To Text File',
        writecsv: 'Write CSV',
        readcsv: 'Read CSV',
        appendvaluetocsvfile: "Append Value To CSV File",
        companyname: 'Company name',
        telnumber: 'Tel number',
        subtitle__actiontask_gmail: 'List of actions for sending and receiving emails.',
        sendmail: 'Send Gmail',
        getgmail: 'Get Gmail',
        gmaildownloadattachments: 'Gmail Download Attachments',
        subtitle__actiontask_calendar: 'List of actions related to Google Calendar integration.',
        getcalendarevents: 'Get Calendar Events',
        createcalendarevent: 'Create Calendar Event',
        removecalendarevent: 'Remove Calendar Event',
        subtitle__actiontask_drive: 'List of actions that operate Google Drive.',
        createdrivefile: 'Create Drive File',
        getdrivefile: 'Get Drive File',
        subtitle__actiontask_docs: 'List of actions to operate Google Docs.',
        createdocs: 'Create Docs',
        getdocs: 'Get Docs',
        docsinsertparagraph: 'Docs Insert Paragraph',
        subtitle__actiontask_spreadsheets: 'List of actions that work with Google Spreadsheets.',
        createspreadsheet: 'Create Spreadsheet',
        getspreadsheet: 'Get Spreadsheet',
        getvalues: 'Get Values',
        updatevalues: 'Update Values',
        appendvalues: 'Append Values',
        clearvalues: 'Clear Values',
        duplicatesheet: 'Duplicate Sheet',
        downloadsheets: 'Download Sheets',
        appendsheet: 'Append Sheet',
        subtitle__actiontask_awss3: 'List of AWS S3 operational actions.',
        uploads3file: 'Upload S3 File',
        downloads3file: 'Download S3 File',
        subtitle__actiontask_webservice: 'List of actions to download files on the web or send HTTP requests.',
        httprequest: 'HTTP Request',
        getfilefromurl: 'Get File From URL',
        subtitle__actiontask_filemaker: 'List of actions that operate FileMaker.',
        getrecords: 'Get Records',
        createrecord: 'Create Record',
        getsinglerecordbyid: 'Get Single Record By Id',
        editrecord: 'Edit Record',
        deleterecord: 'Delete Record',
        duplicaterecord: 'Duplicate Record',
        findrecords: 'Find Records',
        executescript: 'Execute Script',
        uploadtocontainerfield: 'Upload To Container Field',
        setglobalfields: 'Set Global Fields',
        subtitle__actiontask_control: 'List of control actions.',
        loop: 'Loop',
        forearch: 'For-Earch',
        breakif: 'Break Loop/For-Each If',
        wait: 'Wait',
        runrobot: 'Run Robot',
        utcoffset: 'UTC offset',
        subtitle__connections_gmail: 'By linking with the Gmail API, you can use the action to send emails from the linked account.',
        createaconnectionwithgmail: 'Create A Connection With Gmail',
        subtitle__connections_drive: 'By linking with the Google Drive API, you can perform operations such as retrieving, uploading, and deleting files from Google Drive in actions.',
        createaconnectionwithdrive: 'Create A Connection With Google Drive',
        subtitle__connections_calendar: 'By linking with the Google Calendar API, you can use actions to get information from Google Calendar.',
        createaconnectionwithcalendar: 'Create A Connection With Google Calendar',
        subtitle__connections_docs: 'By linking with the Google Docs API, you can create, retrieve, and edit Google Docs.',
        createaconnectionwithdocs: 'Create A Connection With Google Docs',
        subtitle__connections_spreadsheet: 'By linking with the Google Spreadsheet API, you can use actions that allow you to create new spreadsheets and manipulate cells.',
        createaconnectionwithspreadsheet: 'Create A Connection With Google Spreadsheet',
        subtitle__connections_awss3: 'By linking with AWS S3, you can retrieve files from S3 buckets and save files to buckets in actions. Permission to operate the S3 bucket will be his IAM permissions specified in the AWS console. This linkage is a linkage with a fixed bucket.',
        createaconnectionwithawss3: 'Create A Connection With AWS S3',
        subtitle__connections_ftp: 'By linking to FTP you can download files or upload files to FTP and more.',
        createaconnectionwithftp: 'Create A Connection With FTP',
        subtitle__connections_filemaker: 'By linking with the FileMaker API, you can use actions to create, edit, delete records, execute scripts, and more.',
        createaconnectionwithfilemaker: 'Create A Connection With FileMaker',
        subtitle__functions_get: 'List of functions that retrieve current date and time information, file information in the archive, or passed parameters.',
        fxgetcurrentdate: 'GetCurrentDate(UTC offset , Format)',
        fxgetcurrenttime: 'GetCurrentTime(UTC offset , Format)',
        fxgetcurrenttimestamp: 'GetCurrentTimestamp(UTC offset , Format)',
        fxgetfilesizeiniytes: 'GetFilesizeInBytes(File path)',
        fxgetnumberoffiles: 'GetNumberOfFiles(Directory)',
        fxgetscriptparameter: 'GetScriptParameter()',
        subtitle__functions_date: 'List of date functions that calculate dates and manipulate date information.',
        fxday: 'Day(Date)',
        fxdayname: 'DayName(Date)',
        fxdayofweek: 'DayOfWeek(Date)',
        fxdayofyear: 'DayOfYear(Date)',
        fxmonth: 'Month(Date)',
        fxmonthname: 'MonthName(Date)',
        fxweekofyear: 'WeekOfYear(Date)',
        fxyear: 'Year(Date)',
        fxsetdate: 'SetDate(Year, Month, Day, Format)',
        subtitle__functions_text: 'List of text functions that can be used to parse, rearrange, extract, and construct text strings.',
        fxtostring: 'ToString(Text)',
        fxleft: 'Left(Text , Number of characters)',
        fxmiddle: 'Middle(Text , Start , Number of characters)',
        fxright: 'Right(Text , Number of characters)',
        fxstringlength: 'StringLength(Text)',
        fxtolower: 'ToLower(Text)',
        fxtoupper: 'ToUpper(Text)',
        fxpatterncount: 'PatternCount(Text , Search string)',
        fxsubstitute: 'Substitute(Text , [[ Search string , Replace string ]])',
        fxtotrim: 'ToTrim(Text)',
        fxtotrimall: 'ToTrimAll(Text)',
        fxindexofstring: 'IndexOfString(Text , Search string)',
        fxsplit: 'Split(Text , split with)',
        fxmatch: 'Match(Text , RegExp)',
        subtitle__functions_number: 'List of functions used to manipulate numeric data.',
        fxtonumber: 'ToNumber(Text)',
        fxrandom: 'Random()',
        fxtoceiling: 'ToCeiling(Number)',
        fxtofloor: 'ToFloor(Number)',
        subtitle__functions_logical: 'List of logical functions that test a condition to evaluate whether it is true or false.',
        fxif: 'If(Condition , Result 1 , Result 2)',
        fxcase: 'Case([[ Condition , Result ]] , Default result)',
        fxisempty: 'IsEmpty(Text)',
        year: 'Year',
        month: 'Month',
        day: 'Day',
        numberofcharacters: 'Number of characters',
        searchstring: 'Search string',
        replacestring: 'Replace string',
        results: 'Result',
        defaultresult: 'Default result',
        companycategory: 'Company category',
        new: 'New',
        existing: 'Existing',
        excludingholidays: 'Does not run on public holidays',
        excludingweekends: 'Does not run on Saturdays and Sundays',
        else: 'Else',
        endloop: 'End Loop',
        foreach: 'For-each',
        endforeach: 'End For-each',
        viewfile: 'View file',
        sendgmail: 'Send gmail',
        allowedfilesextensionsareasfollows: 'Allowed files extensions are as follows',
        rpacloudssubtitle: 'MORE FREE TIME, MORE OPPORTUNITITES',
        highlightfeatures: [
            {
                title: 'Individual-Oriented'
                , content: 'The sole RPA tool that accommodates individual needs through a wide array of available packages.'
            },
            {
                title: 'Flexibility'
                , content: 'Access from anywhere and at any time, making it easy for users to manage their automation processes remotely.'
            },
            {
                title: 'Multifunctionality'
                , content: 'Automate repetitive tasks effortlessly, even without any knowledge of coding, thanks to its array of features.'
            }
        ],
        frequentlyaskedquestion: 'Frequently Asked Questions',
        frequentlyaskedquestions: [
            {
                question: 'What tasks can be automated using RPA CLOUD?'
                , answer: "Tasks on platforms such as Excel, Gmail, Google Spreadsheet and FileMaker, such as transferring information, extracting data from the web, managing files, auto sending emails, and much more. If you're unsure whether your specific tasks can be automated, don't hesitate to contact us for further information and assistance."
            },
            {
                question: 'What programming languages or skills are required to implement RPA CLOUD?'
                , answer: "No specific skills are required to create your own robots. Simply follow our documentation and you'll be able to develop your own robots."
            },
            {
                question: 'What kind of support is available?'
                , answer: 'We offer support through email and video calls to assist you with any questions or issues you may have.'
            }
        ],
        footerslogan: "Build your own ideal assistant",
        footerscription: "Liberate yourself from mundane tasks using the power of robots!",
        getstarted: 'Get Started',
        introduceblog: "RPA CLOUD believes that everyone desires their own assistant to unleash their potential creativity and have more quality time for individual pursuits.",
        resources: "resources",
        position: 'Position',
        notice: "Notice",
        gobackconfirm: "Do you want to save the script before going back?",
        ftp: 'FTP',
        secure: 'Secure',
        subtitle__actiontask_ftp: 'List of actions for manipulating FTP server.',
        uploadfiletoftp: 'Upload File To FTP',
        downloadfilefromftp: 'Download File From FTP',
        destinationdirectory: 'Destination directory',
        remarks: 'Remarks',
        delimiter: 'Delimiter',
        changedelimitercsvfile: 'Change Delimiter CSV File',
        returndatatype__noreturndata: 'No return data',
        extractdatafromtable: "Extract Data From Table",
        company: 'Company',
        users: 'Users',
        closetab: "Close Tab",
        opennewtab: "Open New Tab",
        clip: "Clip",
        addnewcompany: "Add new company",
        editcompany: "Update company",
        msg_addnewcompanysuccess: 'Add new company successful.',
        msg_updatecompanysuccess: 'Update company successful.',
        msg_inactivecompanywassuccess: 'Inactive company(s) was successful.',
        msg_activecompanywassuccess: 'Active company(s) was successful.',
        msg_deletecompanywassuccess: 'Delete company(s) was successful.',
        confirmactioncompany: 'Do you want to {action} the selected company?',
        company_profile: 'Company Profile',
        handling_of_personal_information: 'Handling of personal information',
        show_histories: 'Show/Hide Histories',
    },
}

export default en;